import lib from './Library'

export default (componentName) => {
  switch (lib) {
    case 'material-ui':
    default: return require(`material-ui-wrapper/lib/components/${componentName}`).default
  }
}
